import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import QueryString from 'qs';
import { firstValueFrom } from 'rxjs';
import { EventManagerAdminService } from '../../event-manager/event-manager-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { UsertokenService } from '@shared-angular/services/usertoken.service';
import { AiImageFile } from './openaiImage.service';

@Injectable({
    providedIn: 'root'
})
export class FalaiImageService {
    constructor(
        private eventManager: EventManagerAdminService,
        private http: HttpClient,
        private botIdService: BotidService,
        private usertokenService: UsertokenService
    ) { }

    public async create(prompt: string, opts: { image?: string, images?: string[], aspectRatio?: string } = {}) {
        this.eventManager._trigger_RAGAI_EVENT("RAGAI.AIIMAGE_FALAI.CREATE.start", { prompt, opts });

        const query = QueryString.stringify({
            prompt,
            ...opts,
            ...(opts.images && { images: JSON.stringify(opts.images) })
        });
        const result = await firstValueFrom(this.http.get<AiImageFile>("/api/ai/image/create/falai/" + this.botIdService.getBotId() + "?" + query));
        this.eventManager._trigger_RAGAI_EVENT("RAGAI.AIIMAGE_FALAI.CREATE.done", { prompt, opts, result });

        return result;
    }

    public getImageUrl(fileId: string) {
        return "/api/ai/image/load/" + this.botIdService.getBotId() + "/" + fileId + "?Ut=" + this.usertokenService.getUserToken();
    }
}
